export class StockTransferLine {
    ItemCode: string = '';
    ItemName: string = '';
    Quantity: number = 1;
    UoMEntry: number = null;
    UoMName: string = '';
    WarehouseCode: string = '';
    FromWarehouseCode: string = '';

    constructor(init?: Partial<StockTransferLine>) {
        if (init) {
            Object.assign(this, init);
        }
    }
}
